import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import AchievementsSection from "../../../shared/AchievementsSection";
import Newsletter from "../../../shared/Newsletter";

/*Tour ------------Card----------- Images*/
import tour39 from "./../../../assets/images/taj-tour1.jpg";
import tour40 from "./../../../assets/images/sameday-tour2.jpg";
import tour41 from "./../../../assets/images/sameday-tour3.jpg";
import tour42 from "./../../../assets/images/sameday-tour7.jpg";
import tour43 from "./../../../assets/images/sameday-tour4.jpg";
import tour44 from "./../../../assets/images/sameday-tour5.jpg";
import tour45 from "./../../../assets/images/sameday-tour8.jpg";
import tour46 from "./../../../assets/images/taj-mahal.jpg";
import tour47 from "./../../../assets/images/raj-desert.png";
import card1 from "./../../../assets/images/city-palace.jpg";
import card2 from "./../../../assets/images/jaipur-village-safari-THUMB.jpg";
import card3 from "./../../../assets/images/night-2.jpg";

import ImageGallery from "../../../components/Gallery/Gallery2";
import TourCardBlock from "../../../shared/TourCardBlock";
import { Helmet } from "react-helmet";
import BookingMainPage from "../../../components/Booking/BookingMainPage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Subtitle from "../../../shared/Subtitle";

const MainSameDay = () => {
  const images = [
    tour39,
    tour40,
    tour41,
    tour42,
    tour43,
    tour44,
    tour45,
    tour46,
    tour47,
  ];

  const [isMobile, setIsMobile] = useState(false);

  const updateIsMobile = () => {
    setIsMobile(window.innerWidth <= 786);
  };

  useEffect(() => {
    updateIsMobile(); // Initial check
    window.addEventListener("resize", updateIsMobile);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const tourData = [
    {
      name: "JAIPUR SIGHTSEEING DAY TOUR",
      category: "Jaipur Tour Packages",
      image: card1,
      city: "Same Day",
      featured: true,
    },
    {
      name: "JAIPUR JEEP SAFARI",
      category: "Jaipur Tour Packages",
      image: card2,
      city: "Same Day",
      featured: true,
    },
    {
      name: "NIGHT OPEN AIR CITY TOURS OF JAIPUR",
      category: "Jaipur Tour Packages",
      image: card3,
      city: "Same Day",
      featured: true,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <Helmet>
        <title>Jaipur Tour Packages! - The Rustic Paths</title>
        <meta
          name="description"
          content="Explore our diverse rajasthan tour packages."
        />
        <meta
          name="keywords"
          content="The Rustic Paths, book a driver in India, tour packages India, Golden Triangle Tour, South India Tour, Rajasthan Tour, Same Day Tour, Same Day Tour, Short Tour"
        />
        {/* Add other meta tags as needed */}
      </Helmet>

      <section>
        <Container>
          <div className="details__info pt-0">
            <section>
              <Container>
                <Row>
                  <Col lg="12">
                    <h1 align="center" className="services__subtitle">
                      Jaipur Tour Packages!
                    </h1>
                  </Col>
                  <p className="para">
                    Discover the vibrant essence of India with The Rustic Paths’
                    Jaipur Tour Packages! Ideal for travelers short on time yet
                    eager for adventure, these expertly crafted itineraries
                    ensure an unforgettable day of exploration through Jaipur’s
                    most iconic landmarks and cultural treasures.
                    <br /> <br />
                    Begin your journey with a visit to the Amber Fort, where the
                    grandeur of Rajasthan’s royal heritage comes to life against
                    a stunning backdrop of rugged hills. Wander through the
                    intricately carved halls and courtyards of this historic
                    fort, marveling at the fusion of Mughal and Rajput
                    architecture. Then, take a trip to the City Palace, a
                    breathta
                    <br /> <br /> With experienced guides and seamless
                    logistics, The Rustic Paths’ Jaipur day tours provide a rich
                    cultural experience and a deeper understanding of Jaipur's
                    unique charm. Embark on a whirlwind journey through the Pink
                    City and make memories that will last a lifetime. Book your
                    Jaipur Tour Package today and let us show you the wonders of
                    Jaipur, one incredible destination at a time!
                  </p>
                  <Link to="/tour-packages/jaipur-tour-packages/jaipur-sightseeing-day-tour">
                    <Button style={{ float: "right" }} className="primary__btn">
                      Know more...
                    </Button>
                  </Link>
                </Row>
              </Container>
            </section>
            {/*--------------------------- Tour Gallery --------------------------*/}
            <section>
              <Container>
                <ImageGallery images={images} />
              </Container>
            </section>
            {/*--------------------------- Tour Gallery End --------------------------*/}
            <section>
              <Container>
                <h1 className="services__subtitle mb-4">
                  Popular Jaipur Tour Packages
                </h1>
                <Row>
                  {/* Display TourCardBlock components */}
                  <Col lg="8" className="details__info">
                    <Row>
                      {tourData.map((tour, index) => (
                        <Col key={index} lg="4">
                          {isMobile ? (
                            <Slider {...settings}>
                              <div key={index}>
                                <TourCardBlock
                                  tour={tour}
                                  buttonText="Book Now"
                                />
                              </div>
                            </Slider>
                          ) : (
                            <TourCardBlock
                              key={index}
                              tour={tour}
                              buttonText="Book Now"
                            />
                          )}
                        </Col>
                      ))}
                    </Row>
                  </Col>
                  <Col
                    lg="4"
                    style={{
                      paddingRight: 0,
                      paddingLeft: window.innerWidth <= 768 ? 0 : "",
                    }}
                  >
                    <BookingMainPage />
                  </Col>
                </Row>
              </Container>
            </section>
            <p className="para">
              <Subtitle subtitle={"Why Choose Us"} textColor={"white"} />
              <li>
                {" "}
                Experienced Guides: Our team of experienced guides ensures a
                safe and memorable travel experience.{" "}
              </li>{" "}
              <li>
                {" "}
                Comfortable Accommodation: Stay in comfortable hotels, resorts,
                or guesthouses throughout your journey.
              </li>{" "}
              <li>
                Hassle-Free Travel: Sit back, relax, and let us take care of all
                the arrangements, from transportation to accommodation and
                sightseeing.
              </li>
            </p>
          </div>
        </Container>
        {/*--------------------------- Our Achievements Section Start--------------------------*/}
        <section>
          <Container>
            <Row>
              <Col lg="12">
                {/* <div style={{ backgroundColor: "#ffffff" }}>
                  <h2 align="center" className="services__subtitle">
                    Few of our achievements
                  </h2>
                </div> */}
                <Subtitle subtitle={"Few of our achievements"} />
              </Col>
              <Col lg="12">
                <AchievementsSection />
              </Col>
            </Row>
          </Container>
        </section>
      </section>

      {/*--------------------------- Our Achievements Section End--------------------------*/}
      <Newsletter />
    </>
  );
};

export default MainSameDay;
